/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data: {
        data: [],
        //分页数据
        selector: '.list',
        api: 'getUserDynamicList',
        param: {
            user_id: qk_author.author_id,
            size: 10
        },
        isDataEmpty:false,
        loading: true,
        locked:false,
    },
    mounted() {
        // 加载数据
        this.loadData();
    },
    methods: {
        // 加载数据
        loadData() {
            this.$nextTick(() => {
                this.$refs.jsonPageNav.load(1, '', true);
            });
        },
        // 接收子组件的传值
        change(data) {
            //this.data = [];
            this.data = this.transformList(data.data);
            this.isDataEmpty = (this.data.length === 0);
            this.loading = !this.loading;
            this.$nextTick(() => {
                //listFadein(document.querySelectorAll('.comments-page .comments-list > li'),10)
            });
            
        },
        transformList(oldList) {
            const newList = oldList.reduce((acc, cur, index) => {
                if ((index+1) % 2 === 0) {
                    acc.even.push(cur); // 将偶数放到新数组的 even 数组中
                } else {
                    acc.odd.push(cur); // 将奇数放到新数组的 odd 数组中
                }
                return acc;
            }, { odd: [], even: [] });
            
            newList.odd.sort((a, b) => parseInt(a.name) - parseInt(b.name));
            newList.even.sort((a, b) => parseInt(a.name) - parseInt(b.name));
            
            return [...newList.odd, ...newList.even]; // 将 odd 和 even 数组合并
        }
    }
};
